
import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'NavigationTab',
  props: {
    items: {
      type: Array as PropType<{path: string, icon?: string, title: string, counter?: number}[]>,
      required: true,
    },
  },
})
